var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('FormulateInput',{attrs:{"value":_vm.value,"options":_vm.data,"placeholder":_vm.placeholder,"type":"select","aria-setsize":"","disabled":_vm.isDisabled},on:{"change":_vm.change}})}
var staticRenderFns = []

export { render, staticRenderFns }